import { useState, useEffect } from "react";

const SESSION_KEY = "disclaimer-acknowledged";

export function DisclaimerDialog() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem(SESSION_KEY)) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  function handleAcknowledge() {
    sessionStorage.setItem(SESSION_KEY, "true");
    setVisible(false);
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
    >
      <div className="bg-white rounded-xl max-w-md w-full p-6 sm:p-8 shadow-xl">
        <div className="mb-4 sm:mb-6">
          <img
            src="/ogp-logo.svg"
            alt="Open Government Products"
            width={180}
            height={60}
            className="h-10 sm:h-12 w-auto"
          />
        </div>

        <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
          This is an experimental prototype built during OGP&apos;s{" "}
          <a
            href="https://www.hack.gov.sg/about-hfpg/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-500 underline hover:text-primary-700"
          >
            Hack for Public Good.
          </a>{" "}
          It is available for testing and feedback purposes only. It may change
          or be discontinued without notice as we learn what works best.
        </p>

        <button
          onClick={handleAcknowledge}
          className="w-full bg-black text-white font-medium py-3 px-6 rounded-lg hover:bg-gray-800 transition-colors text-sm sm:text-base"
        >
          I understand
        </button>
      </div>
    </div>
  );
}
